import classNames from "classnames";
import { forwardRef } from "react";
import { twMerge } from "tailwind-merge";

type TimelineItemDotRootNode = HTMLDivElement;

interface TimelineItemDotProps extends React.HTMLAttributes<TimelineItemDotRootNode> {}

const TimelineItemDot = forwardRef<TimelineItemDotRootNode, TimelineItemDotProps>(({ className, ...props }, ref) => {
  return (
    <div
      className={twMerge(classNames("absolute left-[-0.9rem] h-6 w-6 rounded-full", className))}
      ref={ref}
      {...props}
    />
  );
});

TimelineItemDot.displayName = TimelineItemDot.name;

export default TimelineItemDot;
